export default {
  state: {
    sidebarOn: true,
    default_db: null,
    def_col: 'en',
  },
}
